import { API } from "../../api.js";
import { $, esc, fmtMoney } from "../../ui/format.js";
import { helpIcon } from "../../ui/help.js";

// ---------------------------------------------------------------- Consulting Report

async function renderConsulting(main, snap) {
  main.innerHTML = `
    <h2 class="panel-title">Consulting Report — Month ${snap.month} ${helpIcon("consulting")}</h2>
    <div class="commands"><button id="btn-legacy-report">📊 View Legacy Report (CEO Report Card)</button></div>
    <section class="adv" id="consulting-moves" hidden></section>
    <div id="consulting-content">Loading…</div>
  `;
  // the three moves that matter most now come first (advisor.py), then the full report by area
  fetch(`${API}/advisor`).then((r) => r.json()).then((a) => {
    const box = document.getElementById("consulting-moves");
    if (!box || !a || !(a.moves || []).length || !window.gesAdvHtml) return;
    box.innerHTML = window.gesAdvHtml(a, { report: false });
    box.hidden = false;
    box.querySelectorAll("[data-adv-go]").forEach((b) => b.addEventListener("click", () => window.ges && window.ges.showTab(b.dataset.advGo)));
  }).catch(() => {});
  $("btn-legacy-report").addEventListener("click", openLegacyReportModal);
  const { report } = await (await fetch(`${API}/consulting-report`)).json();
  const SECTION_LABELS = { strategy: "Strategy", finance: "Finance", operations: "Operations", marketing: "Marketing",
                           workforce: "Workforce & hiring", legal: "Legal & regulatory" };
  const PRIORITY_CLASS = { High: "neg", Medium: "", Low: "pos" };

  const allItems = Object.entries(SECTION_LABELS).flatMap(([key, label]) =>
    (report[key] || []).map((item) => ({ ...item, section: label })));
  const topAction = allItems.find((i) => i.priority === "High") || allItems[0];
  const tldr = topAction ? `
    <div class="plain-english-card">
      <strong style="color:var(--brass);">If you only read one thing:</strong>&nbsp;
      ${esc(topAction.section)} — ${esc(topAction.recommendation)}
    </div>
  ` : "";

  const html = tldr + Object.entries(SECTION_LABELS).map(([key, label]) => `
    <h3 style="font-family:var(--font-display); font-size:17px; margin:24px 0 10px;">${label}</h3>
    <table class="ledger" style="margin-bottom:8px;">
      ${(report[key] || []).map((item) => `
        <tr>
          <td class="label" style="width:70px;"><span class="mono ${PRIORITY_CLASS[item.priority]}">${item.priority}</span></td>
          <td style="font-family:var(--font-body);">
            <div style="margin-bottom:4px;">${esc(item.observation)}</div>
            <div style="color:var(--brass); font-size:12.5px;">→ ${esc(item.recommendation)}</div>
          </td>
        </tr>
      `).join("")}
    </table>
  `).join("");
  // how many people each department needs, and where you have too many (workforce_review.py)
  const rv = report.workforce_review;
  const staffing = rv ? `<h3 style="font-family:var(--font-display); font-size:17px; margin:24px 0 10px;">Headcount: what you need</h3>
    <p style="color:var(--text-mid); font-size:13px; margin:0 0 8px;">${esc(rv.headline)} You employ ${rv.total_have.toLocaleString("en-US")}; a company your size needs about ${rv.total_need.toLocaleString("en-US")}.</p>
    <table class="ledger"><tr><th style="text-align:left;">Department</th><th class="num">Have</th><th class="num">Need</th><th class="num">Gap</th><th style="text-align:left;">Verdict</th></tr>
      ${rv.rows.map((r) => `<tr><td>${esc(r.department)}</td><td class="num">${r.have.toLocaleString("en-US")}</td><td class="num">${r.need.toLocaleString("en-US")}</td>
        <td class="num ${r.status === "short" || r.status === "over" ? "neg" : ""}">${r.gap > 0 ? "+" : ""}${r.gap.toLocaleString("en-US")}</td>
        <td>${{ short: "Short", over: "Overstaffed", ahead: "Building ahead", ok: "Right-sized" }[r.status]}${r.excess_cost ? ` · ${fmtMoney(r.excess_cost)}/yr extra` : ""}</td></tr>`).join("")}</table>
    <p style="color:var(--text-low); font-size:12px;">${esc(rv.method)}</p>` : "";
  $("consulting-content").innerHTML = html + staffing;
}

async function openLegacyReportModal() {
  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop";
  backdrop.innerHTML = `
    <div class="modal" style="width:min(620px, 92vw); max-height:82vh; display:flex; flex-direction:column;">
      <h3>Legacy Report</h3>
      <div id="legacy-report-body" style="overflow-y:auto; flex:1;">Loading…</div>
      <div class="modal-actions" style="margin-top:14px; display:flex; gap:8px; justify-content:flex-end;">
        <a id="legacy-card-download" href="${API}/legacy-report/card.png" target="_blank" rel="noopener"
           download="legacy-card.png" style="display:none; font-family:var(--font-body); cursor:pointer;
           border:1px solid var(--line); background:linear-gradient(160deg, #33230f, #221607);
           color:var(--text-hi); border-radius:var(--radius); padding:10px 16px; font-size:13px;
           letter-spacing:0.02em; text-decoration:none; align-self:center;">🖼️ Download Legacy Card</a>
        <button class="primary" id="legacy-close">Close</button>
      </div>
    </div>
  `;
  document.body.appendChild(backdrop);
  backdrop.querySelector("#legacy-close").addEventListener("click", () => backdrop.remove());
  backdrop.addEventListener("click", (e) => { if (e.target === backdrop) backdrop.remove(); });

  const body = backdrop.querySelector("#legacy-report-body");
  try {
    const res = await fetch(`${API}/legacy-report`);
    const data = await res.json();
    if (!res.ok) {
      body.innerHTML = `<p style="color:var(--oxblood);">${esc(data.detail || "Could not generate a Legacy Report.")}</p>`;
      return;
    }
    backdrop.querySelector("#legacy-card-download").style.display = "";
    const rep = data.report;
    const gradeCls = rep.overall_score >= 70 ? "pos" : rep.overall_score >= 40 ? "" : "neg";
    body.innerHTML = `
      <div style="text-align:center; margin-bottom:18px;">
        <div style="font-family:var(--font-display); font-size:44px; font-weight:700;" class="${gradeCls}">${esc(rep.grade)}</div>
        <div style="color:var(--text-mid); font-size:13px;">Overall Score: ${rep.overall_score}/100</div>
      </div>
      <table class="ledger" style="margin-bottom:14px;">
        <tr><td class="label">Financial Strength</td><td class="mono">${rep.scores.financial_strength}/100</td></tr>
        <tr><td class="label">Market Position</td><td class="mono">${rep.scores.market_position}/100 (rank #${rep.world_rank} of ${rep.world_total})</td></tr>
        <tr><td class="label">Organizational Health</td><td class="mono">${rep.scores.organizational_health}/100</td></tr>
        <tr><td class="label">Growth Trajectory</td><td class="mono">${rep.scores.growth_trajectory}/100 (${rep.revenue_growth_multiple}x since founding)</td></tr>
        <tr><td class="label">Achievements</td><td class="mono">${rep.achievements_unlocked}/${rep.achievements_total}</td></tr>
        <tr><td class="label">Status</td><td class="mono">${rep.is_public ? "Public company" : "Private"}</td></tr>
      </table>
      <div class="report-narrative report" style="max-height:200px; overflow-y:auto;">${esc(data.markdown)}</div>
    `;
  } catch (e) {
    body.innerHTML = `<p style="color:var(--oxblood);">Could not reach the server for a Legacy Report.</p>`;
  }
}

export { renderConsulting };
